export const useBillingPath = (suffix = '', params = null) => {
  const prefix = '/app/admin'
  const path = `${prefix}/billing${suffix}`

  if (params) {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      searchParams.set(key, value)
    })
    return `${path}?${searchParams.toString()}`
  }

  return path
}
